<template>
  <transition name="fade-right">
    <div v-if="showing" class="mtx-terms flex align-center px-1 py-1 bg-dark color-white">
      <!-- TODO: update link for matryx privacy policy -->
      <div class="mr-2">
        By using this site, you agree to our
        <br />
        <a href="https://nanome.ai/public-src/downloads/Nanome-Privacy.pdf" target="_blank">
          Privacy Policy
        </a>
        and
        <a href="https://nanome.ai/public-src/downloads/Nanome-TOS.pdf" target="_blank">
          Terms of Service
        </a>
      </div>
      <button @click="hide">Okay</button>
    </div>
  </transition>
</template>

<script>
export default {
  data: () => ({
    showing: false
  }),

  created() {
    this.showing = !localStorage.getItem("mtx-tos-1")
  },

  methods: {
    hide() {
      this.showing = false
      localStorage.setItem("mtx-tos-1", true)
    }
  }
}
</script>

<style lang="scss">
.mtx-terms {
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
